import Card from '@ergeon/core-components/exports/Card.ts';

// Shown only where MeetingPage actually records: the same flag gates both.
const HostRecordingNotice = () => (import.meta.env.VITE_ENABLE_RECORDING ? (
  <Card
    className="px-5 py-4"
    flavor="regular"
    rounded="medium"
    tag="section">
    <p className="paragraph-3 text-gray-600 dark:text-gray-400">
      This call is recorded and transcribed. The customer is told before joining.
    </p>
  </Card>
) : null);

export default HostRecordingNotice;
